import React, { Component } from 'react';
import FAQCategory from '../../../../src/models/FAQCategory';
import FAQCategoryListItemView from './FAQCategoryListItemView';

type FAQCategoryListViewProps = {
    categories: FAQCategory[],
    selectedCategory: FAQCategory,
    categorySelected: (category: FAQCategory) => void
}

export default class FAQCategoryListView extends Component<FAQCategoryListViewProps, any> {
    public render() {
        return (
            <ul className="border rounded d-flex flex-column list-unstyled">
                {
                    this.props.categories.map((cat: FAQCategory, index: number) => {
                        return (
                            <li key={"faqCategory_" + index}>
                                <FAQCategoryListItemView category={cat} categorySelected={this.props.categorySelected} isSelected={this.props.selectedCategory === cat} key={index} first={index === 0} last={index === this.props.categories.length - 1}></FAQCategoryListItemView>
                            </li>
                        );
                    })
                }
            </ul>
        );
    }
}